import React, { useContext, useState } from 'react'
import { BottomDiv, ButtonContainer, ButtonDiv, CloseDiv, Container, Header, InputData, InputDiv, InputLabel } from './style'
import ModalContext from '../../contexts/ModalContext'
import close from '../../assets/close-icon.svg'
import axios from 'axios'
import { FeedbackContext } from '../../contexts/FeedbackContext'

const CreateAFunctionModal = () => {
  const { setModalActive, setModalSection, lastSection } = useContext(ModalContext)
  const { setFeedback } = useContext(FeedbackContext)
  const [ formData, setFormData ] = useState({
    name:''
  })
  
  const handleCreateAFunction = () => {
    axios.post(`${process.env.REACT_APP_PRODUCTION_FLOW_BASE_URL}/functions`, formData)
      .then(response => {
        setFeedback({
          isOpen:true,
          message:'Êxito ao criar função',
          statusOk:true
        })
        setModalSection(lastSection)
      })
      .catch(error => {
        if(error.status == 409){
          setFeedback({
            isOpen:true,
            message:'Função já cadastrada',
            statusOk:false
          })
          return
        }
        setFeedback({
          isOpen:true,
          message:'Falha ao criar função',
          statusOk:false
        })
        console.error(error)
      })
  }
  
  return(
    <Container>
      <Header>
        <h2>Criar função</h2>
        {/* <CloseDiv onClick={() => (setModalActive(false))}>
          <img src={close} />
        </CloseDiv> */}
      </Header>
      <InputDiv>
        {/* <InputLabel>Nome:</InputLabel> */}
        <InputData
          value={formData.name}
          autoFocus
          onChange={(e) => setFormData(() => ({
            name:e.target.value
          }))}
          placeholder='Nome da função...'
        />
      </InputDiv>
      <BottomDiv>
        <ButtonContainer>
          <ButtonDiv className='cancel' onClick={() => setModalSection(lastSection)}>Voltar</ButtonDiv>
          <ButtonDiv className={!formData.name ? 'inactive' : ''} onClick={() => {
            if(!formData.name) return
            handleCreateAFunction()
          }}>Criar</ButtonDiv>
        </ButtonContainer>
      </BottomDiv>
    </Container>
  )
}

export default CreateAFunctionModal